import { IToast } from '@/types/toast';
import { TOASTR_ACTION_TRIGGERED, TOASTR_HIDE_ACTIVE } from './constants';

export function showSuccessToast(message: string) {
  return queueToast({ message, type: 'success' });
}

export function showErrorToast(message: string, action?: string) {
  return queueToast({ message, type: 'error', action });
}

export function showToast(toast: IToast) {
  return {
    type: 'TOASTR_SHOW',
    payload: toast,
  };
}

export function queueToast(toast: IToast) {
  return {
    type: 'TOASTR_QUEUE',
    payload: toast,
  };
}

export function hideActiveToast() {
  return {
    type: TOASTR_HIDE_ACTIVE,
  };
}

export function reset() {
  return {
    type: 'TOASTR_RESET',
  };
}

export function toastrActionTriggered(action: string, payload?: any) {
  return {
    type: TOASTR_ACTION_TRIGGERED,
    action,
    payload,
  };
}
